import { Report } from './report.model';
import { ReportSummary } from './report-summary.model';
import { Discrepancy } from './report-discrepancies.model';

export class ReportResponse {
    report: Report;
    reportSummary: ReportSummary;
    discrepancies: Discrepancy[];
}



// WEBPACK FOOTER //
// ./src/app/report/models/report-response.model.ts